// src/services/analytics/index.ts
import Analytics from "./Analytics";
import { GoogleAnalyticsProvider } from "./providers/GoogleAnalyticsProvider";

export * from "./types";
export { Analytics, GoogleAnalyticsProvider };

// Create and export singleton instance
const analytics = new Analytics({
  debug: import.meta.env.DEV,
});

// Add Google Analytics provider
const gaTrackingId = import.meta.env.VITE_GOOGLE_TAG;
if (gaTrackingId) {
  analytics.addProvider(new GoogleAnalyticsProvider(gaTrackingId));
}

export { analytics };
